export interface BlogPost {
  slug: string;
  title: string;
  excerpt: string;
  body: string;
  category: string;
  date: string;
  author: string;
  img: string;
}

export const BLOG_POSTS: BlogPost[] = [
  {
    slug: 'future-of-laboratory-diagnostics-african-healthcare',
    title: 'The Future of Laboratory Diagnostics in African Healthcare',
    excerpt: 'How modern PCR, ELISA and point-of-care testing are transforming patient outcomes across the continent.',
    category: 'Medical Insights',
    date: 'Feb 24, 2024',
    author: 'Manlab Medicals',
    img: 'https://images.pexels.com/photos/3825377/pexels-photo-3825377.jpeg?auto=compress&cs=tinysrgb&w=1200',
    body: `Harare, Zimbabwe – Modern laboratory diagnostics are reshaping healthcare delivery across Africa. From PCR and ELISA to point-of-care testing, these technologies are improving speed, accuracy, and access.

**A Regional Focus on Diagnostics**

Key developments include:
- **Renewable pathways** for lab equipment supply and maintenance across the continent
- **Cross-border partnerships** for reagent supply chains and training
- **Point-of-care devices** reducing turnaround time in remote clinics
- **CE and FDA-certified equipment** ensuring quality and compliance

Manlab Medicals is committed to supplying certified laboratory equipment, reagents, and consumables to support these initiatives.`,
  },
  {
    slug: 'essential-medical-supplies-rapid-response-clinics',
    title: 'Essential Medical Supplies for Rapid Response Clinics',
    excerpt: 'Checklists for consumables, disposables and equipment every fast-paced clinic should stock.',
    category: 'Healthcare Tech',
    date: 'Jan 15, 2024',
    author: 'Manlab Medicals',
    img: 'https://images.pexels.com/photos/5863400/pexels-photo-5863400.jpeg?auto=compress&cs=tinysrgb&w=1200',
    body: `Quick access to the right supplies can make all the difference in a busy clinic. This guide covers must-have consumables, disposables, and equipment.

**Core checklist**
- Sharps containers and disposal systems
- IV bags, urine bags, and fluid management
- Laryngeal masks and airway supplies
- Wound care and dressings
- Electrosurgical consumables and loop electrodes

We help clinics across Zimbabwe and the region source quality supplies with reliable lead times.`,
  },
  {
    slug: 'understanding-ce-fda-certification-medical-equipment',
    title: 'Understanding CE & FDA Certification for Medical Equipment',
    excerpt: 'What certifications mean for your facility and why they matter for procurement and safety.',
    category: 'Industry News',
    date: 'Dec 10, 2023',
    author: 'Manlab Medicals',
    img: 'https://images.pexels.com/photos/6129040/pexels-photo-6129040.jpeg?auto=compress&cs=tinysrgb&w=1200',
    body: `CE and FDA certifications are central to medical device safety and market access. Here’s what they mean for your facility.

**Why certifications matter**
- **CE marking** indicates conformity with EU health, safety, and environmental standards
- **FDA clearance** applies to devices sold in the United States and is often a global benchmark
- Procurement and tenders increasingly require certified equipment
- Patient safety and liability protection depend on using approved devices

All equipment we supply meets applicable certification requirements for your market.`,
  },
  {
    slug: 'infection-control-sterile-technique-operating-room',
    title: 'Infection Control and Sterile Technique in the Operating Room',
    excerpt: 'Best practices for surgical site safety, instrument handling and theatre hygiene.',
    category: 'Best Practice',
    date: 'Nov 28, 2023',
    author: 'Manlab Medicals',
    img: 'https://images.pexels.com/photos/4769123/pexels-photo-4769123.jpeg?auto=compress&cs=tinysrgb&w=1200',
    body: `Surgical site infections remain a major concern. Adhering to infection control and sterile technique helps protect patients and staff.

**Key practices**
- Proper hand hygiene and gowning
- Sterile field management and instrument handling
- Use of single-use vs reusable devices and reprocessing protocols
- Theatre ventilation and environmental controls
- Sharps safety and disposal

Quality instruments and disposables from trusted suppliers form the foundation of a safe operating environment.`,
  },
];

export function getPostBySlug(slug: string): BlogPost | undefined {
  return BLOG_POSTS.find((p) => p.slug === slug);
}

export function getRelatedPosts(currentSlug: string, limit = 6): BlogPost[] {
  return BLOG_POSTS.filter((p) => p.slug !== currentSlug).slice(0, limit);
}
